import React, { Component } from 'react'

/**
 * Styles
 */
import './PublicChamps.css'

// Modules
import { getChamps } from '../../utils/champsFunctions';

/**
 * Components
 */
import PublicChampsView from './PublicChampsView'

class publicChamps extends Component {

	constructor(props) {
		super(props)
		this.state = {
			arrayOfChamps: [],
			arrayOfChampsOriginal: [],

			loading: true,

			// arrayOfTeams: [],
			// quadroDePesos: [],

			// modalChamp: false,
			// champChoosed: {},
			// modalCompetitors: false,
			// clearInputsCompList: false,
			// modalRegistration: false,
			// modalTeamRegistration: false,
			// modalSwitching: false,
			// clearInputsSwitList: false,
		}
	}

	componentDidMount = () => {

		/* Get all champs */
		this.getChamps();
	}

	/* Get champs */
	getChamps = async () => {
		let localArray = await getChamps();

		this.setState({
			arrayOfChamps: localArray,
			arrayOfChampsOriginal: localArray,
			loading: false
		})
	}

	/* Search champ */
	searchChamp = (value) => {
		let localArray = []
		this.state.arrayOfChampsOriginal.forEach(champ => {
			if (champ.nome.toLowerCase().includes(value.toLowerCase())) {
				localArray.push(champ)
			}
		})
		this.setState({
			arrayOfChamps: localArray
		})
	}

	render() {
		return (
			<PublicChampsView
				loading={this.state.loading}
				arrayOfChamps={this.state.arrayOfChamps}

				searchChamp={e => this.searchChamp(e)}
			/>
		)
	}

}

export default publicChamps